import { CustomInvoicePayload } from '@ecocart/entities';
import { apiCall, PAYMENT_PROJECTS_API } from './api';
import { Invoice } from './payments';

export const createInvoice = (invoicePayload: CustomInvoicePayload): Promise<Invoice> => {
  return apiCall<Invoice>('POST', `${PAYMENT_PROJECTS_API}/invoices`, invoicePayload);
};
